
let prodObj = $('.product').data('obj');
let lastVariantSku = $('.product-variant-sku').val();
let savedDesigns = [];

//Handle custom design link
const handleCustomDesignLink = (init = false) => {
	const designData = localStorage.getItem(`customDesign--${prodObj.productId}`);
	if (designData) {
		let customDesignHash = JSON.parse(designData),
			customDesign = customDesignHash.design_product,
			smallestIndex = [],
			customHash = [];
		savedDesigns = customDesign;
		$('[name="add"]').attr('data-original-product', prodObj.productId);
		if (customDesign.length && (init || !$('.saved-designs').length)) {
			$('.pdp-tabs').append(`
				<li><a class="pdp-tab saved-designs" href="#">Saved Designs</a></li>
			`);
		}
		customDesign.forEach(
			(item, index, object) => {
				let today = new Date();
				let recordDate = new Date(item.created_at);
				const diffTime = Math.abs(today - recordDate);
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
				smallestIndex.push(recordDate);
				customHash.push({
					index: index,
					days: recordDate
				});
				if (diffDays >= 15) {
					object.splice(index, 1);
				}
			}
		);
		//Has saved designs
		if (customDesign.length > 0) {
			let index = 0;
			let maxDate = new Date(Math.max.apply(null, smallestIndex)).getTime();
			customHash.forEach(function (element) {
				if (maxDate == element.days.getTime()) {
					index = element.index;
				}
			})
			customDesignHash.design_product = customDesign;
			localStorage.setItem("customDesign--" + prodObj.productId, JSON.stringify(customDesignHash));
			$(".current_price").text(Shopify.formatMoney(customDesign[index].designProduct.price, "${{amount}}"));
			$('.option-item.is-saved').remove();
			customDesign.forEach((item, i) => {
				const dataString = JSON.stringify(item.designProduct).replace(/"/g, '&quot;');
				const isSelected = i == index;
				let color = item.designProduct.design.design.values[0].name;
				const $firstFieldset = $($("product-info variant-selects fieldset")[0]);
				const isColor = $firstFieldset?.has('.color-options-container');
				let lastOption = isColor ? $firstFieldset.find(".color-options-container > .option-item:last") : $firstFieldset.find("label:last");
				lastOption?.after(`
					<div class="option-item is-saved" data-ATC="${item.designProduct.addToCart}" data-design-id="${item.designProduct.design.id}" data-sku="${item.designProduct.design.design.sku}"> 
						<svg class="icon icon-checkmark" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"></path>
						</svg>
						<input type="radio" id="template--${prodObj.productId}__custom-1-${i}" name="Color" value="${color}" form="product-form-template--${prodObj.productId}__main">
						<label design-data="${dataString}" data-price="${item.designProduct.price}" data-ATC="${item.designProduct.addToCart}" style="background-image:url(${item.designProduct.thumbnail});" data-color="${color}" class="color-swatch variant-swatch round ${isSelected ? 'Selected' : ''}" for="template--${prodObj.productId}__custom-1-${i}">
							<span class="visually-hidden">Variant sold out or unavailable</span>
						</label>
					</div>
				`);
			});
			if (!init) {
				$('.saved-designs').click();
				setTimeout(() => {
					$('.option-item.is-saved label.Selected').click();
				}, 200);
			}
		} else {
			localStorage.removeItem("customDesign--" + prodObj.productId);
		}
	}
};
const renderProductAttributes = (productPreviewObj) => {
    let options = productPreviewObj?.values || [];
	// unitmoq does not always return an array, so we need to convert it to one.
	if (!Array.isArray(options)) {
		options = Object.values(options);
	}
	const validOptions = options.filter(option => option.value != "n/a" && option.value != "");
	if (validOptions.length > 0) {
		$('.item_details').addClass('shown');
	}
	let leatherSrc = validOptions.filter(option => option.type?.toLowerCase()?.includes('leather'))[0]?.thumbnail;
	if (!leatherSrc) {
		leatherSrc = validOptions.filter(option => option.name?.toLowerCase()?.includes('main leather'))[0]?.thumbnail;
		if (!leatherSrc) {
			leatherSrc = validOptions.filter(option => option.name?.toLowerCase()?.includes('leather'))[0]?.thumbnail;
		}
	}
	if (leatherSrc) {
		$('.material-callout-image img').attr('src', leatherSrc);
	}
	validOptions.forEach(function (value, indexValue) {
		if (value.label != "n/a") {
			$("form.product-form").append(`<input type="hidden" class="hidden-attributes" name="properties[` + value.name + `]" value="` + value.label + `" />`)
			$(".item_details").append(`
				<li class="item_details-row" data-sku="${value.sku}" data-component-id="${value.component_id}">
					<div class="item_details-popup">
						<img src="${value.thumbnail}" alt="${value.label}" class="item_details-popup-image">
						<div class="item_details-popup-content">
							<span class="title">${value.label}</span>
							${value.description ? `<span class="description">${value.description}</span>` : ''}
						</div>
					</div>
					<div class="item_details-content-container">
						<img src="${value.thumbnail}" alt="${value.label}" class="item_details-image">
						<div class="item_details-content">
							<span class="heading">${value.name}</span>
							<span class="value">${value.label}</span>
						</div>
					</div>
					<button data-component-id="${value.component_id}" class="item_details-edit">
						<svg class="icon icon-edit" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M15.6237 1.94765L16.0524 2.37632C16.3854 2.70934 16.3854 3.24785 16.0524 3.57733L15.0214 4.61182L13.3882 2.9786L14.4191 1.94765C14.7522 1.61462 15.2907 1.61462 15.6201 1.94765H15.6237ZM7.43276 8.93756L12.1872 4.1796L13.8204 5.81282L9.06244 10.5672C8.9597 10.67 8.83216 10.7444 8.69399 10.7833L6.62146 11.375L7.21311 9.30247C7.25208 9.1643 7.32648 9.03676 7.42922 8.93402L7.43276 8.93756ZM13.2181 0.746642L6.22821 7.73301C5.91999 8.04123 5.6968 8.42031 5.57989 8.83482L4.56665 12.3776C4.48162 12.6752 4.56311 12.994 4.78276 13.2137C5.00241 13.4334 5.32126 13.5148 5.61886 13.4298L9.16164 12.4166C9.57969 12.2961 9.95877 12.0729 10.2634 11.7682L17.2534 4.78187C18.2489 3.78635 18.2489 2.17084 17.2534 1.17532L16.8247 0.746642C15.8292 -0.248881 14.2136 -0.248881 13.2181 0.746642ZM3.11765 2.12833C1.39586 2.12833 0 3.52418 0 5.24598V14.8823C0 16.6041 1.39586 18 3.11765 18H12.754C14.4758 18 15.8717 16.6041 15.8717 14.8823V10.9144C15.8717 10.4432 15.4926 10.0642 15.0214 10.0642C14.5502 10.0642 14.1711 10.4432 14.1711 10.9144V14.8823C14.1711 15.6653 13.537 16.2995 12.754 16.2995H3.11765C2.33469 16.2995 1.70054 15.6653 1.70054 14.8823V5.24598C1.70054 4.46302 2.33469 3.82886 3.11765 3.82886H7.08557C7.55676 3.82886 7.93584 3.44979 7.93584 2.9786C7.93584 2.50741 7.55676 2.12833 7.08557 2.12833H3.11765Z" fill="currentColor"/>
						</svg>
					</button>
				</li>
			`);
		}
	});
}
const loadProductPreview = (sku) => {
	if (sku) {
		$('.variant-loader').show();
		try {
			window.x?.loadPreview(document.getElementById('product-preview-container'), sku, (previewData) => {
				$('.variant-loader').hide();
				$('.gallery-image').removeClass('shown');
				$('.product_gallery').removeClass('hidden');
				$(".item_details").html('');
				sessionStorage.setItem("sku-" + previewData.sku, JSON.stringify(previewData));
				updateSku(previewData.sku);
                // NOTE: using a temporary "draft" version of the response.
                renderProductAttributes(previewData.draft);
			});
		} catch (error) {
			console.log('err', error);
		}
	}
};
const handleProductPreviewUpdated = (e) => {
	let data = e?.detail?.data;
	if (e?.design) {
		data = {
			options: e?.design?.design?.values.map(option => ({
				name: option.component_name,
				component_id: option.component_id,
				value: option.value,
				thumbnail: option.image,
				type: option.type,
				label: option.name
			})),
			design_id: e?.design?.design?.sku,
			sku: e?.design?.design?.sku,
			thumbnail: e?.design?.image,
			price: e?.design?.design?.price
		};
	}
	//renderProductAttributes(data);
	const sku = data?.design_id;
	if (sku) {
		updateSku(sku);
		$('.variant-loader').show();
		sessionStorage.setItem("sku-" + sku, JSON.stringify(data));
	}
	else {
		$('.product_gallery').removeClass('hidden');
		$(".item_details").html('');
	}
}

function updateSku(sku) {
	lastVariantSku = sku;
	$('.product-variant-sku').val(sku);
	$('.customize-opener').attr('data-sku', sku);
}
function updateImages(designObj, product_id) {
	$(".product_gallery img").attr("src", designObj.product.thumbnail);
	$(".product_gallery").css("opacity", 1);
	$(".product_gallery img").css("opacity", 1);
	$(".product_gallery .thumbnail").css("visibility", "visible");
	$(".current_price").text(Shopify.formatMoney(designObj.product.price, $('body').data('money-format')));
	let customDesign = JSON.parse(localStorage.getItem("customDesign--" + product_id)).design_product;
	if (customDesign.length) {
		handleCustomDesignLink();
	}
}
function openDesigner(componentId=null) {
	const customerId = prodObj.customerId;
	const current_product_id = prodObj.productId;
	if (customerId) {
		window.laudividni?.setDesignerId(customerId);
	}
	let designer = window.laudividni?.openDesignTool(lastVariantSku, 
		function (designObj) {
		designer.close();
		let url = window.location.pathname + "?design=" + designObj.product.design.id;
		let productHash = {
			product: current_product_id,
			design_product: [{
				designProduct: designObj.product,
				created_at: new Date().toISOString(),
				url
			}]
		};
		if (localStorage.getItem("customDesign--" + current_product_id)) {
			let currentDesigns = JSON.parse(localStorage.getItem("customDesign--" + current_product_id));
			currentDesigns.design_product.push({
				designProduct: designObj.product,
				created_at: new Date().toISOString(),
				url,
			});
			localStorage.setItem("customDesign--" + current_product_id,
				JSON.stringify({
					product: current_product_id,
					design_product: currentDesigns.design_product
				})
			);
		} else {
			localStorage.setItem("customDesign--" + current_product_id, JSON.stringify(productHash));
		}
		updateImages(designObj, current_product_id);
		setTimeout(() => window.dispatchEvent(new CustomEvent('customDesignSaved', {
			bubbles: true,
			detail: designObj
		})), 100);
		if (designObj.action === 'Add To Cart') {
			setTimeout(function () {
				const $customBtn = $("[name=add]");
				if ($customBtn.length) {
					$customBtn.click();
				}
			}, 2000);
		}
	}, 
	{
		...(componentId ? { cid: componentId } : {}),
		btnLabel: ['Save Your Design', 'Add To Cart']
	});
}
const handleDeeplinkingToDesign = () => {
	var urlParams = new URLSearchParams(window.location.search);
	var designId = urlParams.get('design') ?? null;
	if (!urlParams.has('variant') && designId) {
		let checkExist = setInterval(function() {
			const designEl = document.querySelector(`.option-item[data-design-id="${designId}"] label`);
			const designsTab = document.querySelector('.pdp-tab.saved-designs');
			if (designEl && designsTab) {
				clearInterval(checkExist);
				designsTab.click();
				setTimeout(() => {
					designEl.click();
				}, 200);
			}
		}, 500);
	}
	else if (urlParams.has('variant')) {
		$('.color-options-more').click();
	}
}

function eventsInit() {
	$('.gallery-image').addClass('shown');
	$('body').on("click", ".customize-opener", function (e) {
		e.preventDefault();
		e.stopPropagation();
		lastVariantSku = $(this).attr('data-sku');
		openDesigner();
		if ($('.product[data-type="saved-designs"]').length) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'saved_design',
				ecommerce: {
					detail: {
						products: [{
							id: prodObj.productId,
							name: prodObj.productTitle,
							category: prodObj.category,
							leather: 'leather_name',
							lining: prodObj.lining,
							hardware: '+ value.label +',
							price: prodObj.variantPrice,
						}]
					}
				}
			});
		}
	});
	$('body').on('click', '.item_details-edit', (e) => {
		e.preventDefault();
		e.stopPropagation();
		const componentId = e.currentTarget.getAttribute('data-component-id');
		openDesigner(componentId);
	});
	$('body').on('click', '.thumbnail-slider .thumbnail', function (e) {
		const $clickedThumbnail = $(this);
		const $allThumbnails = $('.thumbnail-slider .thumbnail');
		const clickedIndex = $allThumbnails.index($clickedThumbnail);
		const isMainImage = clickedIndex === 0;
		
		if (isMainImage && lastVariantSku) {
			// Reload the 360 preview for the main image
			loadProductPreview(lastVariantSku);
		} else {
			// Show static image for other thumbnails
			$('.gallery-image').addClass('shown');
			$('.product_gallery').addClass('hidden');
		}
	});
	$('body').on('click', '.product[data-type="saved-designs"] [name=add]', function (e) {
		e.preventDefault();
		const $addToCartBtn = $(this);
		const atcText = $addToCartBtn.find('.atc-text').data('atcText');
		$addToCartBtn
			.attr('disabled', 'disabled')
			.addClass('disabled')
			.addClass('loading')
			.find('.atc-text')
			.text(`Adding to cart...`)
			.addClass('animated')
			.addClass('fadeInDown');
		$addToCartBtn.find('.loading__spinner').removeClass('hidden');
		const atcAtttr = $('.option-item.is-saved:has(input:checked)').attr('data-atc');
		let originalProduct = $addToCartBtn.attr("data-original-product");
		let customDesignHash = JSON.parse(localStorage.getItem("customDesign--" + originalProduct));
		let selectedIndex = 0,
			isCreated = false;
		let customDesign = customDesignHash?.design_product;
		if (customDesign) {
			customDesign.forEach((item, index) => {
				if (item.designProduct.addToCart == atcAtttr) {
					selectedIndex = index;
					if (item.variant_id || item.product_id) {
						isCreated = true;
					}
				}
			});
		}
		let obj = {};
		$('input[name^="properties["]').each(function() {
			if ($(this).val()) {
				obj[$(this).attr('name').replace('properties[', '').replace(']', '')] = $(this).val();
			}
		});
		if (!isCreated) {
			$.get(atcAtttr, function (data) {
				if (data) {
					customDesign[selectedIndex].variant_id = data.variant_id;
					customDesign[selectedIndex].product_id = data.product_id;
					customDesignHash.design_product = customDesign;
					localStorage.setItem("customDesign--" + originalProduct, JSON.stringify(customDesignHash));
					let sessionData = JSON.parse(sessionStorage["sku-" + customDesign[selectedIndex].designProduct.design.design.sku]);
					if (sessionData?.draft) {
						sessionData = sessionData.draft;
					}
					let values = sessionData?.values;
					Object.values(values)?.forEach(function (element) {
						if (element.label != "" && element.label != "n/a") {
							obj[element.name] = element.label;
						}
					});
					let Cartdata = {
						"id": data.variant_id,
						"quantity": 1,
						"properties": obj
					}
					jQuery.ajax({
						type: 'POST',
						url: '/cart/add.js',
						data: Cartdata,
						dataType: 'json',
						success: function (data) {
							jQuery.ajax({
								type: 'GET',
								url: '/cart.js',
								dataType: 'json',
								success: function (cart) {
									if (window.innerWidth > 600) {
										refreshCart(cart);
									} else {
										window.location.href = "/cart";
									}
									// refreshCart(cart);
									// if (window.innerWidth > 749) {
									// 	const cartDrawer = document.querySelector('.cart-drawer, [data-cart-drawer]');
									// 	if (cartDrawer) {
									// 		cartDrawer.classList.add('active', 'open');
									// 		document.body.classList.add('cart-drawer-open');
									// 	}
									// }
									$addToCartBtn
										.removeClass('loading')
										.removeClass('disabled')
										.removeClass('animated')
										// .prop('disabled', false)
										.removeClass('fadeInDown')
										.find('.atc-text').text(`${atcText}`)
										.addClass("fadeInDown")
										.addClass("added")
										.removeClass('animated')
										.removeClass('zoomOut');
									$addToCartBtn.find('.loading__spinner').addClass('hidden');
								}
							})
						}
					});
				}
			});
		} else {
			let sessionData = JSON.parse(sessionStorage["sku-" + customDesign[selectedIndex].designProduct.design.design.sku]);
			if (sessionData?.draft) {
				sessionData = sessionData.draft;
			}
			let sessionValues = sessionData?.values;
			Object.values(sessionValues)?.forEach(function (element) {
				if (element.label != "" && element.label != "n/a") {
					obj[element.name] = element.label;
				}
			});
			let Cartdata = {
				"id": customDesign[selectedIndex].variant_id,
				"quantity": 1,
				"properties": obj
			}
			// jQuery.post('/cart/add.js', Cartdata, (data) => {
			// 	jQuery.get('/cart.js', (response) => {
			// 		console.log('response', response);
			// 		const cart = JSON.parse(response);
			// 		if (window.innerWidth > 749) {
			// 			window.location.reload();
			// 		}
			// 		refreshCart(cart);
			// 		$addToCartBtn
			// 			.removeClass('loading')
			// 			.removeClass('disabled')
			// 			.prop('disabled', false)
			// 			.removeClass('animated')
			// 			.removeClass('fadeInDown')
			// 			.find('.atc-text').text(`${atcText}`)
			// 			.addClass("fadeInDown")
			// 			.removeClass('animated')
			// 			.removeClass('zoomOut');
			// 		$addToCartBtn.find('.loading__spinner').addClass('hidden');
			// 	});
			// });
			jQuery.post('/cart/add.js', Cartdata, (data) => {
				jQuery.get('/cart.js', (response) => {
					// console.log('response', response);
					const cart = JSON.parse(response);
					if (window.innerWidth > 749) {
						window.location.reload();
					}
					refreshCart(cart);
					$addToCartBtn
						.removeClass('loading')
						.removeClass('disabled')
						.prop('disabled', false)
						.removeClass('animated')
						.removeClass('fadeInDown')
						.find('.atc-text').text(`${atcText}`)
						.addClass("fadeInDown")
						.removeClass('animated')
						.removeClass('zoomOut');
					$addToCartBtn.find('.loading__spinner').addClass('hidden');
				});
			});
		}
	});
}

function refreshCart(cart) {
	window.location.reload();
	// const cartDrawer = document.querySelector('cart-drawer');
	// cartDrawer.renderContents(cart);
	// const cartCount = cart.item_count;
	// const cartCountElements = document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count]');
	// cartCountElements.forEach(element => {
	// 	element.textContent = cartCount;
	// 	element.style.display = cartCount > 0 ? 'block' : 'none';
	// });
	// document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
}
const pdpTabs = () => {
    $('body').on('click', '.pdp-tabs .pdp-tab', function (e) {
        e.preventDefault();
        const $pdpTabs = $('.pdp-tabs .pdp-tab');
        $pdpTabs.removeClass('active');
        const $tab = $(this);
        const newType = $tab.hasClass('custom') ? 'custom' : ($tab.hasClass('saved-designs') ? 'saved-designs' : 'rts');
        $tab.addClass('active');
        $('.product').attr('data-type', newType);
    });
    $('body').on('click', '.custom-switch-btn', function (e) {
        e.preventDefault();
        $('.pdp-tab.custom').click();
        const breadcrumbs = document.querySelector('.breadcrumbs');
        if (breadcrumbs) {
            const rect = breadcrumbs.getBoundingClientRect();
            if (rect.top < 0) {
                breadcrumbs.scrollIntoView({ behavior: 'smooth' });
            }
        }
    });
};
class VariantSelects extends HTMLElement {
	constructor() {
	  super();
	  this.addEventListener('change', this.onVariantChange);
	  this.isGiftCard = false;
	  if (!this.dataset.type.includes('gift-card')) {
		loadProductPreview(lastVariantSku);
	  }
	  else {
		$('.variant-loader').hide();
		this.isGiftCard = true;
	  }
	}
	
	onVariantChange(event) { 
		const $target = $(event.target);
		if ($target.parent().hasClass('option-item') || this.isGiftCard) {
			const $parent = $target.parent();
			const $label = $parent.find('label');
			const isSaved = $parent.hasClass('is-saved');
			updateSku($parent.attr('data-sku'));
			let sku = lastVariantSku;
			if (isSaved && !this.isGiftCard) {
				const customDesign = JSON.parse($label.attr('design-data'));
				this.currentVariant = customDesign.design.design;
				this.currentVariant.id = customDesign.design.id;
				sku = this.currentVariant.sku;
			}
			if (sku) {
				this.updateOptions();
				if (!isSaved) {
					this.updateMasterId();
					this.toggleAddButton(true, '', false);
					this.updatePickupAvailability();
					this.updateVariantStatuses();
				}
				this.updateSelectedSwatchValue(event);
				this.removeErrorMessage();
			
				if (!this.currentVariant) {
					this.toggleAddButton(true, '', true);
					this.setUnavailable();
				} else {
					this.updateURL($target);
					this.updateVariantInput();
					this.renderProductInfo();
					this.updateShareUrl();
				}
				if (!this.isGiftCard) {
					loadProductPreview(sku);
				}
				$(`.option-item:not([data-sku="${sku}"]) input:checked`).removeAttr('checked').prop('checked', false);
			}
		}
	}

	updateOptions() {
	  this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
		if (element.tagName === 'SELECT') {
		  return element.value;
		}
		if (element.tagName === 'FIELDSET') {
		  return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
		}
	  });
	}
  
	updateMasterId() {
	  this.currentVariant = this.getVariantData().find((variant) => {
		return !variant.options
		  .map((option, index) => {
			return this.options[index] === option;
		  })
		  .includes(false);
	  });
	}
  
	updateSelectedSwatchValue({ target }) {
	  const { name, value, tagName } = target;
	  if (tagName === 'SELECT' && target.selectedOptions.length) {
		const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
		const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
		if (!selectedDropdownSwatchValue) return;
		if (swatchValue) {
		  selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
		  selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
		} else {
		  selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
		  selectedDropdownSwatchValue.classList.add('swatch--unavailable');
		}
  
		selectedDropdownSwatchValue.style.setProperty(
		  '--swatch-focal-point',
		  target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
		);
	  } else if (tagName === 'INPUT' && target.type === 'radio') {
		  $('#selected-color').text(` ${value}`);
	  }
	}
  
	updateURL($target) {
	  if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
	  let params = `variant=${this.currentVariant.id}`;
	  const savedDesignId = $target.closest('.option-item')?.data('designId');
	  if (savedDesignId) {
		params = `design=${savedDesignId}`;
	  }
	  window.history.replaceState({}, '', `${this.dataset.url}?${params}`);
	}

	updateShareUrl() {
	  const shareButton = document.getElementById(`Share-${this.dataset.section}`);
	  if (!shareButton || !shareButton.updateUrl) return;
	  shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
	}
  
	updateVariantInput() {
	  const productForms = document.querySelectorAll(
		`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
	  );
	  productForms.forEach((productForm) => {
		const input = productForm.querySelector('input[name="id"]');
		input.value = this.currentVariant.id;
		input.dispatchEvent(new Event('change', { bubbles: true }));
	  });
	}
  
	updateVariantStatuses() {
	  const selectedOptionOneVariants = this.variantData.filter(
		(variant) => this.querySelector(':checked').value === variant.option1
	  );
	  const inputWrappers = [...this.querySelectorAll('.product-form__input')];
	  inputWrappers.forEach((option, index) => {
		if (index === 0) return;
		const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
		const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
		const availableOptionInputsValue = selectedOptionOneVariants
		  .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
		  .map((variantOption) => variantOption[`option${index + 1}`]);
		this.setInputAvailability(optionInputs, availableOptionInputsValue);
	  });
	}
  
	setInputAvailability(elementList, availableValuesList) {
	  elementList.forEach((element) => {
		const value = element.getAttribute('value');
		const availableElement = availableValuesList.includes(value);
  
		if (element.tagName === 'INPUT') {
		  element.classList.toggle('disabled', !availableElement);
		} else if (element.tagName === 'OPTION') {
		  element.innerText = availableElement
			? value
			: window.variantStrings.unavailable_with_option.replace('[value]', value);
		}
	  });
	}
  
	updatePickupAvailability() {
	  const pickUpAvailability = document.querySelector('pickup-availability');
	  if (!pickUpAvailability) return;
  
	  if (this.currentVariant && this.currentVariant.available) {
		pickUpAvailability.fetchAvailability(this.currentVariant.id);
	  } else {
		pickUpAvailability.removeAttribute('available');
		pickUpAvailability.innerHTML = '';
	  }
	}
  
	removeErrorMessage() {
	  const section = this.closest('section');
	  if (!section) return;
  
	  const productForm = section.querySelector('product-form');
	  if (productForm) productForm.handleErrorMessage();
	}
  
	updateMedia(html) {
	  const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
	  const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
  
	  const refreshSourceData = () => {
		const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
		const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
		const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
		return [mediaGallerySourceItems, sourceSet, sourceMap];
	  };
  
	  if (mediaGallerySource && mediaGalleryDestination) {
		let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
		const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
		const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
		let shouldRefresh = false;
		// add items from new data not present in DOM
		for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
		  if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
			mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
			shouldRefresh = true;
		  }
		}
  
		// remove items from DOM not present in new data
		for (let i = 0; i < mediaGallerySourceItems.length; i++) {
		  if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
			mediaGallerySourceItems[i].remove();
			shouldRefresh = true;
		  }
		}
  
		// refresh
		if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
  
		// if media galleries don't match, sort to match new data order
		mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
		  const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
  
		  if (sourceData && sourceData.index !== destinationIndex) {
			mediaGallerySource.insertBefore(
			  sourceData.item,
			  mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
			);
  
			// refresh source now that it has been modified
			[mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
		  }
		});
	  }
  
	  if (this.currentVariant.featured_media) {
		document
		  .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
		  ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
	  }
  
	  // update media modal
	  const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
	  const newModalContent = html.querySelector(`product-modal`);
	  if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
	}
  
	renderProductInfo() {
	  const requestedVariantId = this.currentVariant.id;
	  const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
	  updateSku(this.currentVariant.sku);
	  fetch(
		`${this.dataset.url}?variant=${requestedVariantId}&section_id=${
		  this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
		}`
	  )
		.then((response) => response.text())
		.then((responseText) => {
		  // prevent unnecessary ui changes from abandoned selections
		  if (this.currentVariant.id !== requestedVariantId) return;
  
		  const html = new DOMParser().parseFromString(responseText, 'text/html');
		  const destination = document.getElementById(`price-${this.dataset.section}`);
		  const source = html.getElementById(
			`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
		  const skuSource = html.getElementById(
			`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
		  const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
		  const inventorySource = html.getElementById(
			`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
		  const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
  
		  const volumePricingSource = html.getElementById(
			`Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
  
		  // this.updateMedia(html);
  
		  const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
		  const pricePerItemSource = html.getElementById(
			`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
		  );
  
		  const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
		  const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
		  const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
  
		  if (volumeNote) volumeNote.classList.remove('hidden');
		  if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
		  if (qtyRules) qtyRules.classList.remove('hidden');
  
		  if (source && destination) destination.innerHTML = source.innerHTML;
		  if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
		  if (skuSource && skuDestination) {
			skuDestination.innerHTML = skuSource.innerHTML;
			skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
		  }
  
		  if (volumePricingSource && volumePricingDestination) {
			volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
		  }
  
		  if (pricePerItemSource && pricePerItemDestination) {
			pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
			pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
		  }
  
		  const price = document.getElementById(`price-${this.dataset.section}`);
  
		  if (price) price.classList.remove('hidden');
  
		  if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');
  
		  const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
		  this.toggleAddButton(
			addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
			window.variantStrings.soldOut
		  );
  
		  publish(PUB_SUB_EVENTS.variantChange, {
			data: {
			  sectionId,
			  html,
			  variant: this.currentVariant,
			},
		  });
		});
	}
  
	toggleAddButton(disable = true, text, modifyClass = true) {
	  const productForm = document.getElementById(`product-form-${this.dataset.section}`);
	  if (!productForm) return;
	  const addButton = productForm.querySelector('[name="add"]');
	  const addButtonText = productForm.querySelector('[name="add"] > span');
	  if (!addButton) return;
  
	  if (disable) {
		addButton.setAttribute('disabled', 'disabled');
		if (text) addButtonText.textContent = text;
	  } else {
		addButton.removeAttribute('disabled');
	  }
  
	  if (!modifyClass) return;
	}
  
	setUnavailable() {
	  const button = document.getElementById(`product-form-${this.dataset.section}`);
	  const addButton = button.querySelector('[name="add"]');
	  const addButtonText = button.querySelector('[name="add"] > span');
	  const price = document.getElementById(`price-${this.dataset.section}`);
	  const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
	  const sku = document.getElementById(`Sku-${this.dataset.section}`);
	  const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
	  const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
	  const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
	  const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
  
	  if (!addButton) return;
	  addButtonText.textContent = window.variantStrings.unavailable;
	  if (price) price.classList.add('hidden');
	  if (inventory) inventory.classList.add('hidden');
	  if (sku) sku.classList.add('hidden');
	  if (pricePerItem) pricePerItem.classList.add('hidden');
	  if (volumeNote) volumeNote.classList.add('hidden');
	  if (volumeTable) volumeTable.classList.add('hidden');
	  if (qtyRules) qtyRules.classList.add('hidden');
	}
  
	getVariantData() {
	  this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
	  return this.variantData;
	}
}
customElements.define('variant-selects', VariantSelects);

$(document).ready(function() {
	handleCustomDesignLink(true);
	handleDeeplinkingToDesign();
	eventsInit();
	pdpTabs();
});